export const ONBOARDING_ENABLE_ADD_REQUEST = "ONBOARDING_ENABLE_ADD_REQUEST";
export const ONBOARDING_ENABLE_ADD_RESPONSE = "ONBOARDING_ENABLE_ADD_RESPONSE";